import styled from 'styled-components';

export const HeaderContainer = styled.header`
  border-bottom: 1px solid ${({ theme }) => theme.black.a1};
  border-top: 1px solid ${({ theme }) => theme.black.a1};
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;
`;

export const SupTitle = styled.h5`
  font-size: 0.8rem;
  line-height: normal;
  letter-spacing: 0.3px;
  text-align: center;
  color: ${({ theme }) => theme.baseBlue.a6};
  margin: 0;
  font-weight: normal;
  text-transform: uppercase;
`;

export const ItemTitle = styled.h1`
  font-size: 2.333rem;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.baseBlue.a10};
  margin-top: 5px;
  text-align: center;
`;

export const ItemDescription = styled.div`
  font-size: 1rem;
  line-height: 1.733rem;
  letter-spacing: 0.3px;
  color: ${({ theme }) => theme.baseBlue.a6};
  text-align: center;
  margin-top: 15px;
  /* IE11 */
  max-width: 100%;
`;

export const RightCol = styled.div`
  display: flex;
  justify-content: flex-end;
`;
